<div class="container py-4">
  <div class="headerTxt mb-4">
    <h3 class="title">{{ workWeekLabel.workWeek }}</h3>
    <div class="ml-4 d-flex align-items-center bg-white">
      <nz-date-picker [nzDisabledDate]="disableNonMondays" (ngModelChange)="onDateChange($event)"
      [ngModel]="wwDate" nzFormat="MM-dd-yyyy"></nz-date-picker>
    </div>
  </div>
  <div class="row">
    <div class="col-md-4 mb-4">
      <div class="row">
        <!-- CREW TYPE (Clear Selection) -->
        <div class="col-md-12 p-8">
          <button type="button" class="col-md-12 btn-style" (click)="clearCrewTypeList()">
            {{ workWeekLabel.crewType }}
          </button>
          <div class="overflow-auto crewTypeList" [ngClass]="{ showLoader: showCrewTypeLoader }">
            <ul class="list-group">
              @for (
                scheduleJobsCrewType of scheduleJobsCrewTypeList; track
                scheduleJobsCrewType; let i = $index) {
                <li [ngClass]="{ selected: selectedCrewTypeValue === scheduleJobsCrewType.crew_Type }"
                  (click)="getScheduleJobsCrewList(scheduleJobsCrewType.crew_Type)">
                  <span class="divisionId">{{
                    scheduleJobsCrewType.crew_Type
                  }}</span>
                  <span class="disc">{{
                    scheduleJobsCrewType.crew_Type_Desc
                  }}</span>
                </li>
              }
            </ul>
            @if (showCrewTypeLoader) {
              <mat-progress-spinner color="primary" mode="indeterminate"
              diameter="50"></mat-progress-spinner>
            }
          </div>
        </div>

        <!-- CREW (Clear Selection) -->
        <div class="col-md-12 p-8">
          <button type="button" class="col-md-12 btn-style" (click)="clearCrewList()">
            {{ workWeekLabel.crew }}
          </button>
          <div class="overflow-auto crewList"
            [ngClass]="{ showLoader: showCrewLoader || crewNotFound !== '' }">
            <ul class="list-group">
              @for (scheduleJobsCrew of scheduleJobsCrewList; track scheduleJobsCrew; let i = $index) {
                <li
                  [class.selected]="selectedCrewValues.includes(scheduleJobsCrew.crew)"
                  (click)="onCrewListitemClick($event, scheduleJobsCrew.crew)">
                  <span class="divisionId">{{scheduleJobsCrew?.crew}}</span>
                  <span class="disc">{{scheduleJobsCrew?.crew_Desc}}</span>
                </li>
              }
            </ul>
            @if (scheduleJobsCrewList.length === 0) {
              <p>{{ crewNotFound }}</p>
            }
            @if (showCrewLoader) {
              <mat-progress-spinner color="primary" mode="indeterminate"
              diameter="50"></mat-progress-spinner>
            }
          </div>
        </div>
      </div>
    </div>

    <!-- DIVISION (Clear Selection) -->
    <div class="col-md-4 mb-8 p-8">
      <button type="button" class="col-md-12 btn-style" (click)="clearDivisionList()">
        {{ workWeekLabel.division }}
      </button>
            <div class="containerHeight" [ngClass]="{
                            showLoader: showdivisionLoader || divisionNotFound !== ''
                          }">
        <ul class="list-group">
          @for (scheduleJobsDivision of scheduleJobsDivisionList; track scheduleJobsDivision; let i = $index) {
            <li [class.selected]="selectedDivisionValues.includes(scheduleJobsDivision.divisionId)"
              (click)="onDivisionitemClick($event, scheduleJobsDivision.divisionId)"
              >
              <span class="divisionId">{{scheduleJobsDivision.divisionId}}</span>
              <span class="disc">{{scheduleJobsDivision.divisionDescription}}</span>
            </li>
          }
        </ul>
        @if (scheduleJobsDivisionList.length === 0) {
          <p>{{ divisionNotFound }}</p>
        }
        @if (showdivisionLoader) {
          <mat-progress-spinner color="primary" mode="indeterminate"
          diameter="50"></mat-progress-spinner>
        }
      </div>
    </div>

    <!-- UNIT (Clear Selection) -->
    <div class="col-md-4 mb-8 p-8">
      <button type="button" class="col-md-12 btn-style" (click)="clearUnitList()">
        {{ workWeekLabel.unit }}
      </button>
      <div class="containerHeight" [ngClass]="{ showLoader: showUnitLoader || unitNotFound !== '' }">
        <ul class="list-group">
          @for (unitsByDivision of scheduleJobsUnitList; track unitsByDivision; let i = $index) {
            <li [class.selected]="selectedUnitValues.includes(unitsByDivision.unitId)"
              (click)="onUnititemClick($event, unitsByDivision.unitId)"
              >
              <span class="divisionId">{{unitsByDivision.unitId}}</span>
              <span class="disc">{{unitsByDivision.unitDescription}}</span>
            </li>
          }
        </ul>
        @if (scheduleJobsUnitList.length === 0) {
          <p>{{ unitNotFound }}</p>
        }
        @if (showUnitLoader) {
          <mat-progress-spinner color="primary" mode="indeterminate"
          diameter="50"></mat-progress-spinner>
        }
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-4">
      <p class="note-txt blue-txt">{{workWeekLabel.noteTxt}}</p>
    </div>
    <div class="col-md-4">
      <div class="row p-8">
        <button type="button" class="col-md-12 btn btn-primary" (click)="seeSchedule()">
          {{ btnTxt.seeSchedule }}
        </button>
      </div>
    </div>

    <div class="col-md-4">
      <div class="flex items-center">
        <input class="form-check-input" type="checkbox" id="laborHours" [(ngModel)]="isLaborhrsChecked" />
        <label class="form-check-label ml-18 note-txt" for="laborHours">{{
          workWeekLabel.includeLaborHours
        }}</label>
      </div>
      <div class="form items-center">
        <input class="form-check-input" type="checkbox" id="scheduledHours"
          [(ngModel)]="isScheduledHrsChecked" />
          <label class="form-check-label ml-18 note-txt" for="scheduledHours">{{
            workWeekLabel.includeScheduledHours
          }}</label>
        </div>
        <div class="form items-center">
          <input class="form-check-input" type="checkbox" id="scheduleCategory"
            [(ngModel)]="isCategoryCodeChecked" />
            <label class="form-check-label ml-18 note-txt" for="scheduleCategory">{{
            workWeekLabel.includeScheduleCategory }}</label>
          </div>
          <div class="form items-center">
            <input class="form-check-input" type="checkbox" id="manpowerHeadcount"
              [(ngModel)]="isManPowerHoursChecked" />
              <label class="form-check-label ml-18 note-txt" for="manpowerHeadcount">{{
              workWeekLabel.includeManpowerHeadcount }}</label>
            </div>
          </div>
        </div>
      </div>